<template>
  <div class="home">
    <HomePage msg="Welcome to Your Vue.js App" />
    <div class>
      <values-page />
      <!-- <div class="columns is-multiline is-mobile"> -->
      <!-- <working-steps /> -->
      <!-- </div> -->
      <join-group />
      <footer-bar />
    </div>
  </div>
</template>

<script>
import HomePage from "@/components/HomePage.vue";
import ValuesPage from "@/components/ValuesPage.vue";
// import WorkingSteps from "@/components/WorkingSteps.vue";
import JoinGroup from "@/components/JoinFBGroup.vue";
import FooterBar from "@/components/FooterBar.vue";

export default {
  name: "Home",
  components: {
    HomePage,
    // WorkingSteps,
    FooterBar,
    ValuesPage,
    JoinGroup
  }
};
</script>
